"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCompanyBody$ = exports.GetCompanyBody$outboundSchema = exports.GetCompanyBody$inboundSchema = void 0;
exports.getCompanyBodyToJSON = getCompanyBodyToJSON;
exports.getCompanyBodyFromJSON = getCompanyBodyFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetCompanyBody$inboundSchema = z.object({
    company_name: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "company_name": "companyName",
    });
});
/** @internal */
exports.GetCompanyBody$outboundSchema = z.object({
    companyName: z.string(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        companyName: "company_name",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetCompanyBody$;
(function (GetCompanyBody$) {
    /** @deprecated use `GetCompanyBody$inboundSchema` instead. */
    GetCompanyBody$.inboundSchema = exports.GetCompanyBody$inboundSchema;
    /** @deprecated use `GetCompanyBody$outboundSchema` instead. */
    GetCompanyBody$.outboundSchema = exports.GetCompanyBody$outboundSchema;
})(GetCompanyBody$ || (exports.GetCompanyBody$ = GetCompanyBody$ = {}));
function getCompanyBodyToJSON(getCompanyBody) {
    return JSON.stringify(exports.GetCompanyBody$outboundSchema.parse(getCompanyBody));
}
function getCompanyBodyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetCompanyBody$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'GetCompanyBody' from JSON`);
}
//# sourceMappingURL=getcompanybody.js.map